<template>
  <v-form ref="form">
    <v-container>
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <div>
            <v-file-input
              ref="inputFile"
              v-model="data.work_sheet"
                :error-messages="errors.work_sheet"
              accept=".docx"
              prepend-icon="mdi-cloud-upload"
              label="upload the work sheet in docx format"
              solo
              @change="file"
            ></v-file-input>
          </div>
        </v-col>

        <v-col cols="12" md="6" sm="6">
          <div>
            <v-select
              solo
              :items="subjects"
                :error-messages="errors.subject"

              item-text="subject_name"
              item-value="subject_code"
              label="Select Subject"
              v-model="data.subject"
            ></v-select>
          </div>
        </v-col>

        <v-col cols="12" md="6" sm="6">
          <div>
            <v-select
              solo
              :items="months"
                :error-messages="errors.month"

              item-text="name"
              item-value="name"
              label="Select Month"
              v-model="data.month"
            ></v-select>
          </div>
        </v-col>

        <v-col cols="12" md="6" sm="6">
          <div>
            <v-select
              solo
              :items="classes"
                :error-messages="errors.class_id"

              item-text="class_name"
              item-value="class_id"
              label="Select Class"
              v-model="data.class_id"
            ></v-select>
          </div>
        </v-col>

             <v-col cols="12" md="6" sm="6">
          <div>
            <label>Select Week </label>
            <v-select
              solo
              :items="weeks"
                :error-messages="errors.week"

              item-text="name"
              item-value="name"
              label="Select Week"
              v-model="data.week"
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="6" sm="6">
          <div>
            <label>Select Version </label>
            <v-select
              solo
              :items="version"
                :error-messages="errors.version"

              item-text="version"
              item-value="version"
              label="Version"
              required
              v-model="data.version"
            ></v-select>
          </div>
        </v-col>

         <v-col cols="6" md="6" sm="6">
          <div>
              <v-container
                class="px-0"
                fluid
              >
              </v-container>
          </div>
        </v-col>
        <v-col cols="6" md="6" sm="6">
              <!-- <v-container
                class="px-0"
                fluid
              > -->
                <v-checkbox
                  v-model="data.answer_sheet"
                  :label="`Answer Sheet`"
                ></v-checkbox>
              <!-- </v-container> -->
          </v-col>

      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn color="#6A158E" @click="save()" large dark>Save</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Form from "../../utils/form/Form";
import { bus } from '../../main';
export default {
  name: "UploadWorkSheet",
  data() {
    return {
      errors:{},
      weeks: [{ name: " 1" }, { name: " 2" }, { name: " 3" }, { name: " 4" }],
      subjects: [],
      version: [
        { version: "1" },
        { version: "2" },
        { version: "3" },
        { version: "4" },
        { version: "5" },
        { version: "6" },
        { version: "7" },
        { version: "8" },
        { version: "9" },
        { version: "10" },
      ],
      months: [
        { name: "1 (September)" },
        { name: "2 (October)" },
        { name: "3 (November)" },
        { name: "4 (December)" },
        { name: "5 (January)" },
        { name: "6 (February)" },
        { name: "7 (March)" },
        { name: "8 (April)" },
        { name: "9 (May)" },
        { name: "10 (June)" },
        { name: "11 (July)" },
        { name: "12 (August)" },
      ],
      classes: [],
      data: {
        week:"",
        month: "",
        class_id: "",
        subject: null,
        version: "",
        work_sheet: null,
        answer_sheet : false,
      },
    };
  },
  methods: {
    file(e) {
      this.data.work_sheet = event.target.files[0];
    },
    save() {
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.WorkSheet.url)
        .then((response) => {
                    bus.$emit('workSheetUpload');
          this.errors = {};
          this.$refs.form.reset();
          this.$refs.inputFile.reset();
             Toast.fire({
              icon: "success",
              title: "Worksheet Upload Successfully",
              
            });
        })
        .catch((response) => {
          if (response.status === 422) {
            this.errors = response.data.errors;
              Toast.fire({
              icon: "error",
              title: "Oops...",
              text: "Server Error",
            });
          }
        });
    },
    getItems() {
      axios.get(apiRoutes.classes.url).then((response) => {
        this.classes = response.data.response;
        this.loading = false;
      });
    },
    getSubject() {
      axios.get(apiRoutes.subjects.url).then((response) => {
        // console.log(response);
        this.subjects = response.data.response;
        // console.log(this.subjects);
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getItems();
    this.getSubject();
  },
};
</script>
